let forms = {
	request_finance: {
		icon: 'fa fa-user',
		title: 'Request Finance',
		subtitle: 'Request bank ipf',
		forms: [
			// {
			//    type: 'select', class: 'col-12', model: 'finance_type', filterable: true, clearable: true,
			//    options: [
			//       {val: 'full', label: 'Fully Financed'},
			//       {val: 'partial', label: 'Partially Financed'},
			//    ], validation: 'required', label: 'Finance Type'
			// },
			{
				type: 'text',
				form_type: 'text',
				class: 'col-12',
				model: 'amount',
				validation: 'required|min:3|max:150|numeric',
				label: 'Amount',
				placeholder: 'Enter the amount',
			},
			{
				type: 'slider',
				step: 1,
				min: 1,
				max: 12,
				model: 'period',
				label: 'Loan Term in Months',
				show_stops: true,
				class: 'col-12',
				validation: 'required',
			},
			{
				type: 'slider',
				step: 1,
				min: 1,
				max: 28,
				model: 'preferred_payment_date',
				label: 'Preferred Payment Date',
				show_stops: true,
				class: 'col-12',
				validation: 'required',
			},
		],
	},
	accept_terms: {
		icon: 'fa fa-user',
		title: 'Mobile Topup',
		subtitle: 'Provide mobile details',
		forms: [
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'terms',
				validation: 'required',
				label: 'I agree to nexus <a href="https://agency.nexus.ke/static/media/Nexus%20General%20Terms%20and%20Conditions%2027.7.2020.fa4a0a2ac647c2df199c.pdf"  class="bold" target="_blank">Terms &amp; Conditions</a>',
			},
		],
	},
	accept_bank: {
		icon: 'fa fa-user',
		title: 'Mobile Topup',
		subtitle: 'Provide mobile details',
		forms: [
			{
				type: 'checkbox',
				class: 'col-12 custom-check',
				model: 'terms',
				validation: 'required',
				label: 'I agree to the <a href="https://agency.nexus.ke/static/media/Nexus%20General%20Terms%20and%20Conditions%2027.7.2020.fa4a0a2ac647c2df199c.pdf"  class="bold" target="_blank">Terms &amp; Conditions</a> for bank.',
			},
		],
	},
	loan_payment_options: {
		icon: 'fa fa-user',
		title: 'Request IPF',
		subtitle: 'Request bank ipf',
		forms: [
			{
				type: 'select',
				class: 'col-12',
				model: 'payment_option',
				filterable: true,
				multiple: true,
				clearable: true,
				options: [],
				validation: '',
				label: 'Payment Option',
			},
		],
	},
};

module.exports = {
	forms: utils.generateAllFormData(forms),
};
